import { net_common } from "@/api/http";
// 「データ管理の達人」からのインポート画面表示
export const API_DisplayCubeBopDbInfoListScreen = (...params) =>
  net_common.post("/api/STDSDC01C20/DisplayCubeBopDbInfoListScreen", ...params);